import React, { useEffect, useState } from 'react';
import fetch from '../Utils/fetch';
import _ from 'lodash';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import ProductSlider from './ProductSlider';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { addRecentlyViewed } from '../../store/recentlyViewed';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/alert';
import { capitalizeFirst, setFavicon } from '../Utils/functions';
import { Button, CircularProgress, IconButton, Skeleton } from '@mui/material';
import Universalpageheader from '../Headers/universalpageheader';
import { AddShoppingCart, ChevronRight, Favorite, FavoriteBorder, StarBorder, StarHalf, Share, Star, Add, Remove } from '@mui/icons-material';
import { addFavorite, removeFavorite } from '../../store/favorites';
import { imageurl, setToStore } from '../Utils/fn';
import { addCartItems, removeCartItem, updateCartItem } from '../../store/cartItems';
import constants from "./../Utils/constants.json"
import { AddBox, IndeterminateCheckBox, HomeOutlined, Phone } from "@mui/icons-material";
import Searchbar from '../Components/searchbar';
import { primarycolor } from '../Utils/colors';

function ProductPage() {
    useDocumentTitle('View Product');

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation()
    const itemURL = location.pathname.split("/")[2];
    const [nothing, setnothing] = useState(false);


    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
    const webSettings = useSelector((state) => state.webSettings.data);
    const cartItems = useSelector((state) => state.cartItems.data);
    const favorites = useSelector((state) => state.favorites.data);
    const subProducts = useSelector((state) => state.subProducts.data);

    const [product, setproduct] = useState('');
    const [similarProducts, setSimilarProducts] = useState([]);
    const [similarProductsLoading, setSimilarProductsLoading] = useState(true);
    const [loading, setloading] = useState(false);
    const [isCartItem, setIsCartItem] = useState(false);
    const [isFavorite, setIsFavorite] = useState(false);
    const [quantity, setQuantity] = useState(1);

    const [showsearchbar, setshowsearchbar] = useState(false);



    useEffect(() => {
        window.scrollTo(0, 0);
        fetchsingleproduct()
        setshowsearchbar(false)
        setproduct('')
        //console.log(product);
    }, [itemURL]);

    useEffect(() => {
        setQuantity(parseInt(product.quantity) || 1);
    }, [product]);

    useEffect(() => {
        checkitemincart(product)
    }, [nothing]);




    const fetchsingleproduct = () => {
        setloading(true);
        setSimilarProductsLoading(true)
        fetch
            .get('item-details', { item_url: itemURL })
            .then((res) => {
                setloading(false)
                if (res.data) {
                    const temproduct = res.data
                    setproduct(temproduct)
                    fetchSimilarProducts(temproduct.item_code);
                    window.scroll({ top: 0, behavior: 'smooth' });
                    dispatch(addRecentlyViewed(temproduct));
                    checkitemincart(temproduct)

                    setFavicon(temproduct.src[0])
                    document.title = temproduct.item_name
                    document.querySelector('meta[name="description"]').setAttribute('content', `${temproduct.item_name},price: ${temproduct.price}`);
                } else {
                    dispatch(setAlert({ type: 'error', message: 'Error loading product details!! ' }));
                }

            })
            .catch((err) => {
                setloading(false)
                dispatch(setAlert({ type: 'error', message: 'Error loading product details!! ' + err.message }));
            });
    }

    function fetchSimilarProducts(item_code) {
        fetch
            .get('getSimilarProducts', { item_code: item_code })
            .then((res) => {
                setSimilarProducts(res.list);
                setSimilarProductsLoading(false);
            })
            .catch((err) => {
                dispatch(setAlert({ type: 'error', message: 'Error loading similar products!! ' + err.message }));
                setSimilarProductsLoading(false);
            });
    }

    //check if item is in cart
    const checkitemincart = (temproduct) => {
        if (temproduct) {
            setToStore(constants.CART_ITEMS, cartItems);
            let found = false;
            cartItems.forEach((item, index) => {
                if (item.item_code === temproduct.item_code) {
                    found = true;
                    setQuantity(item.quantity);
                }
            });
            setIsCartItem(found);

            //favorites
            let favouritefound = false;
            favorites.forEach((item) => {
                if (item.item_code === temproduct.item_code) {
                    favouritefound = true;
                }
            });
            setIsFavorite(favouritefound);
        }
    }



    function addToFavorite() {
        dispatch(addFavorite(product));
        setnothing(!nothing)
    }

    function removeFromFavorite() {
        dispatch(removeFavorite(product.item_code));
        setnothing(!nothing)
    }


    const productprice = product?.promotion_price > 0 ? product.promotion_price : product.price
    const url = `${window.location.host}/product/${product.itemURL}`

    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Details"} withbackicon={true} />
            <div>
                <div className='wrapproductimages'>
                    {product ? product.src?.map((val, key) => {
                        return (
                            <div className='wrapproductimage'>
                                <img src={imageurl(val)} key={key} />
                            </div>
                        )
                    }) :
                        <div className='wrapproductimage'>
                            <Skeleton variant="rectangular" sx={{ height: 200, width: 300, borderRadius: 2, marginTop: 5, marginBlock: 5 }} />
                        </div>
                    }
                </div>

                <div className='pagemini'>
                    {product && capitalizeFirst(product?.item_name)}
                    {!product && <Skeleton variant="rectangular" sx={{ height: 10, width: 200, marginBottom: 2 }} />}
                    {product && <div className="brandname">Brand: &nbsp;<div style={{ color: "navy" }}>{product?.brandName} | {product.group_name}</div> </div>}
                    {!product && <Skeleton variant="rectangular" sx={{ height: 10, width: 100, marginBottom: 2 }} />}
                    {product?.promotion_price > 0 ?
                        <h1 className="pricetextdis">
                            {webSettings.CURRENCY} {product.promotion_price}
                            <div className='discountpriceview'>{webSettings.CURRENCY} {parseFloat(product.price)?.toFixed(2)}</div>
                        </h1> :
                        product ?
                            <h1 className="pricetext">  {webSettings.CURRENCY} {productprice}</h1> :
                            <Skeleton variant="rectangular" sx={{ height: 20, width: 100, marginBottom: 2 }} />
                    }
                    {product && webSettings.ITEMS_OUTOFSTOCK_LABEL === 'Y' && <div className='unitslefttext'>{product.closing > 0 ? `In stock` : <text className='outofstocktext'>Out of stock</text>}</div>}
                    {!product && <Skeleton variant="rectangular" sx={{ height: 10, width: 80, marginBottom: 2 }} />}
                    <div className='wrapsharediv'>
                        {product && <Ratings product={product} />}
                        {!product && <Skeleton variant="rectangular" sx={{ height: 10, width: 100 }} />}
                        <div style={{ display: "flex" }}>
                            {product &&
                                <IconButton>
                                    <Share sx={{ color: "orange" }} />
                                </IconButton>}
                            {!product && <Skeleton variant="circular" sx={{ height: 40, width: 40, marginRight: 2 }} />}
                            {!product && <Skeleton variant="circular" sx={{ height: 40, width: 40 }} />}
                            {product &&
                                <IconButton
                                    sx={{ color: "orange" }}
                                    title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                                    onClick={() => (isFavorite ? removeFromFavorite() : addToFavorite())}
                                >
                                    {isFavorite ? <Favorite /> : <FavoriteBorder />}
                                </IconButton>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className='pagemini'>
                {!similarProductsLoading && <h2 className="title">Related Products</h2>}
                {!similarProductsLoading && similarProducts.length > 0 && <ProductSlider products={similarProducts} />}
                {!similarProductsLoading && similarProducts.length == 0 && <section style={{ padding: '10px' }}>We did not find any match for the product you selected</section>}
                {similarProductsLoading && Array.from({ length: 20 }, (_, index) => {
                    return (
                        <div>
                            <Skeleton variant="rectangular" sx={{ height: 50, width: 450, marginBottom: 2 }} />
                            <ProductSlider products={[]} />
                        </div>
                    )
                })}
            </div>
            {recentlyViewed && recentlyViewed.length > 0 && (
                <div className="sections">
                    <section className="sectionheader">
                        <div className="sectionheadertitle">Recently viewed</div>
                        <Button onClick={() => navigate(`/recents`)} endIcon={<ChevronRight />}>View All</Button>
                    </section>
                    {<ProductSlider products={recentlyViewed} />}
                </div>
            )}
            {product && <Quantitypop temproduct={product} />}
        </div>
    );
}


const Ratings = ({ product }) => {
    const ratingTotal = product.reviews?.reduce((sum, review) => review.rating + sum, 0)
    const average = (ratingTotal / product?.reviews?.length)?.toString().substring(0, 3);



    return (
        <div className="ratings">
            <Stars rating={average == 'NaN' ? 3.5 : average} />
            {product.reviews?.length > 0 && `(${product.reviews?.length} Ratings)`}
        </div>
    )
}

const Stars = ({ rating }) => {
    // Calculate the number of full stars and half stars
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    // Create an array to store the star components
    const starsArray = [];

    // Add full stars
    for (let i = 0; i < fullStars; i++) {
        starsArray.push(<Star key={i} />);
    }

    // Add half star if necessary
    if (hasHalfStar) {
        starsArray.push(<StarHalf key="half" />);
    }

    // Fill the rest with empty stars
    const totalStars = 5;
    while (starsArray.length < totalStars) {
        starsArray.push(<StarBorder key={starsArray.length} />);
    }

    return <div className="productstars">{starsArray}</div>;
};


const Quantitypop = ({ temproduct }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const cartItems = useSelector(state => state.cartItems.data);
    const [product, setproduct] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [isCartItem, setIsCartItem] = useState(false);

    const [nothing, setnothing] = useState(false);




    useEffect(() => {
        setQuantity(parseInt(product?.quantity) || 1);
    }, [product]);

    useEffect(() => {
        const itemincart = cartItems?.find((obj) => obj.item_code == temproduct.item_code)
        setproduct(itemincart ? itemincart : temproduct)
        checkitemincart(temproduct)
    }, [temproduct, cartItems, nothing]);

    useEffect(() => {
        setToStore('cart-items', cartItems);
    }, [cartItems]);


    //check if item is in cart
    const checkitemincart = (temproduct) => {
        if (temproduct) {
            setToStore(constants.CART_ITEMS, cartItems);
            let found = false;
            cartItems.forEach((item, index) => {
                if (item.item_code === temproduct.item_code) {
                    found = true;
                    setQuantity(item.quantity);
                }
            });
            setIsCartItem(found);
        }
    }


    function removeFromCart() {
        dispatch(removeCartItem(product.item_code));
        dispatch(setAlert({ type: 'warning', message: 'Item removed from Cart' }));
        setnothing(!nothing)
    }


    function addToCart(e) {
        dispatch(addCartItems([{ ...product, quantity }]));
        dispatch(setAlert('Item added to Cart'));
        setnothing(!nothing)
    }

    function updater(quantity) {
        if (product.closing >= quantity) {
            if (quantity === product.quantity) {
                // we will alert something here for the user
                return;
            }
            dispatch(updateCartItem({ ...product, quantity }));
        } else {
            dispatch(setAlert({ type: 'error', message: 'Item Out of stock' }));
        }
    }

    return (
        <div className='quantitypopupdiv'>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="callbutton" onClick={() => navigate("/home")} >
                    <HomeOutlined color="primary" />
                </div>
                <div className="callbutton" >
                    <Phone color="primary" />
                </div>
                {isCartItem ?
                    <div className="quantitybuttons" style={{ width: "60%" }} >
                        <div className="callbutton" style={{ backgroundColor: primarycolor }} onClick={() => product.quantity == 1 ? removeFromCart() : updater(product.quantity > 1 ? product.quantity - 1 : 1)}>
                            <Remove />
                        </div>
                        <div className='quantitytext'>{product.quantity}</div>
                        <div className="callbutton" style={{ backgroundColor: primarycolor }} onClick={() => updater(product.quantity + 1)}>
                            <Add />
                        </div>
                    </div> :
                    <Button disabled={product?.closing == 0} onClick={() => addToCart()} fullWidth variant="contained" startIcon={<AddShoppingCart sx={{ fontSize: 20 }} />}>ADD TO CART</Button>}
            </div>
        </div>
    )

}
export default ProductPage;
